import {Component, Input} from '@angular/core';

@Component({
  selector: 'sellions-loading',
  templateUrl: 'sellions-loading.html'
})
export class SellionsLoadingComponent {
  @Input()
  private headerText: string;
  @Input()
  private contentText: string;
  @Input()
  private loading: boolean;
  @Input()
  private noEntries: boolean;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-loading/sellions-loading.ts